var Long = require('long');

function ConversationId(val) {
    this.val = val;
}

ConversationId.prototype.toString = function() {
    return this.val.toString(10);
};

ConversationId.prototype.toValue = function() {
    return this.toString();
};

ConversationId.fromString = function(val) {
    return new ConversationId(Long.fromString(val, false));
};

module.exports = ConversationId;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/conversation/conversation-id.js
// module id = 189
// module chunks = 1